import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is software in construction?",
    answer: `<p>Construction software is a suite of tools designed to help streamline every phase of a construction project, from planning to execution. Automating tasks and connecting various workflows enhances team collaboration, improves resource management, and boosts overall productivity.`,
  },
  {
    question: "What is the cost of developing custom construction software?",
    answer: ` <p>The cost of developing custom construction software can range from $30,000 to $250,000, depending on factors like software complexity, the number of features, design requirements, and the location of the development team. Tekrevol works closely with clients to create a budget that reflects the unique requirements of their construction software, ensuring cost-effectiveness without compromising on quality.</p>`,
  },
  {
    question: "How long does it take to deliver construction software?",
    answer: `<p>The timeline for delivering custom construction software generally takes 6 to 9 months, depending on the project scope and complexity. At Tekrevol, we follow an agile-driven process to ensure timely delivery, with continuous collaboration and adjustments to meet your evolving needs from inception through testing and final release.</p>`,
  },
  {
    question: "Why should I develop construction management software?",
    answer: `<p>Developing construction management software helps centralize communication across teams and stakeholders, ensuring seamless collaboration in real time. With Tekrevol’s construction management software, everyone from project managers to contractors can access updates, reports, and task assignments, regardless of their location, reducing delays and improving project outcomes.</p>`,
  },
  {
    question:
      "Can you integrate construction software with our existing systems?",
    answer: `<p>Yes, Tekrevol specializes in integrating custom construction software with your existing systems such as ERP, CRM, and project management tools. This ensures seamless data flow between departments, improving operational efficiency and decision-making, and giving you full control over your construction processes.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg"
      style={{ background: "#001B28" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>Construction Software</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
